import type { RouteLocationRaw, RouteRecordRaw } from "vue-router";
import {customAsyncComponent} from "@/functions/customAsyncComponent";
import {LOCALE_CATEGORIES} from "@/assets/locales/categories.ts";

export function getResetPasswordRouteRecord():RouteRecordRaw{
  return {
    name: 'reset_password',
    path: '/reset-password',
    component: customAsyncComponent(async () => import('./views/ResetPasswordView.vue')),
    meta: {
      noAuth: true,
      localeCategories: [
        LOCALE_CATEGORIES.RESET_PASSWORD,
        LOCALE_CATEGORIES.ERRORS,
      ]
    },
  }
}

export function getResetPasswordRouteLocation():RouteLocationRaw{
  return { name: 'reset_password' }
}